let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8hOn0")).then(() => parcelRequire('85Nk7'));